/**
 * Main Entry Point
 * Hlavní bundle pro celou aplikaci
 */

// Import Bootstrap JS
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Import stylů (SASS entry point)
import '../css/sass/styles.sass';

// Import custom modulů
import '../lib/owlcarousel/owl.carousel.js';
import './navbar.js';
import './cart.js';
import './carousel.js';
import './back-to-top.js';
import './order.js';
import './order-completion.js';
import './purchase-tracking.js';
import './cookieconsent-config.js';
import './formvalidation.js';
import './drmax-categories.js';

console.log('✓ Main bundle loaded');
